import { gql } from '@apollo/client'

export default gql`
  mutation BuyDailyCheckInShopItem($input: PurchaseDailyCheckInShopItemInput!) {
    purchaseDailyCheckInShopItem(input: $input) {
      isPurchaseSuccess
    }
  }
`
